import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  Grid,
  Chip,
  CircularProgress,
  Tooltip,
} from "@mui/material";

import {
  ZoomIn,
  Handshake,
  AssignmentTurnedIn,
  PendingActions,
  ThumbUp,
  ThumbDown,
  Description,
} from "@mui/icons-material";
import * as Constants from "../../../support/Constants";
import * as Web3Manager from "../../../support/Web3Manager";

import { CompromisoSociosAdheridosFilterMobile } from "./CompromisoSociosAdheridosFilterMobile";

import { DetallePersonaFormMobile } from "../../socios/DetallePersonaFormMobile";
import { DetalleEmpresaFormMobile } from "../../socios/DetalleEmpresaFormMobile";
import { ModalColaboracionesFormMobile } from "../../colaboraciones/ModalColaboracionesFormMobile";
import * as Common from "../../../support/Common";
import moment from "moment";

export const CompromisoSociosAdheridosCard = ({
  adhesiones,
  isLoading,
  showSpinner,
  getEstadoCompromisoSocio,
  getDeadlineDate,
  getApplicationNameToShow,
  handleDetalleSocio,
  handleColaborarConSocio,
  openModalDetallePersona,
  handleCloseModalDetallePersona,
  personaSeleccionada,
  openModalDetalleEmpresa,
  handleCloseModalDetalleEmpresa,
  empresaSeleccionada,
  openModalColaboracion,
  handleCloseModalColaboracion,
  socios,
  principios,
  compromisos,
  categoriasColaboracion,
  setLoading,
  modalColaboracionInitData,
  filtroNombre,
  setFiltroNombre,
  buscarAdhesiones,
  compromiso,
}) => {
  const getMemberType = (value) => {
    if (value === Constants.MEMBER_TYPE_PERSONA) {
      return "Persona";
    } else if (value === Constants.MEMBER_TYPE_EMPRESA) {
      return "Empresa";
    } else {
      return "N/A";
    }
  };

  const getChipInfo = (status) => {
    switch (status) {
      case "Cumple":
        return {
          icon: <AssignmentTurnedIn style={{ color: "green" }} />,
          label: "Cumple",
          color: "success",
        };
      case "Tiene intención":
        return {
          icon: <PendingActions style={{ color: "orange" }} />,
          label: "Tiene intención",
          color: "warning",
        };
      default:
        return {
          icon: null,
          label: "Desconocido",
          color: "default",
        };
    }
  };

  const iconMap = {
    AYUDA: Handshake,
    VALIDACION: ThumbUp,
    DENUNCIA: ThumbDown,
  };

  const startDate = "1900-01-01";
  const endDate = moment().format("YYYY-MM-DD");
  const order = ["AYUDA", "VALIDACION", "DENUNCIA"];
  const normalize = (text) =>
    text.normalize("NFD").replace(/\p{Diacritic}/gu, "");

  const categories = categoriasColaboracion
    .map(({ category }) => {
      const normalized = normalize(category);
      return {
        original: category,
        normalized,
        icon: iconMap[normalized],
      };
    })
    .filter(({ normalized }) => order.includes(normalized))
    .sort((a, b) => order.indexOf(a.normalized) - order.indexOf(b.normalized))
    .map(({ original, icon }) => ({
      name: original,
      icon,
    }));

  return (
    <Box sx={{ flexGrow: 1 }}>
      <CompromisoSociosAdheridosFilterMobile
        filtroNombre={filtroNombre}
        setFiltroNombre={setFiltroNombre}
        buscarAdhesiones={buscarAdhesiones}
        showSpinner={showSpinner}
      />

      {isLoading && !showSpinner ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "50vh",
          }}
        >
          <CircularProgress size={50} />
        </Box>
      ) : adhesiones.length === 0 ? (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" color="text.secondary" align="center">
            No hay socios adheridos para mostrar.
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={2}>
          {adhesiones.map((sociosComp, index) => {
            const status = getEstadoCompromisoSocio(sociosComp);

            const { icon, label, color } = getChipInfo(status);

            const collaborations = sociosComp.collaborations || {};
            const hasAnyCount = categories.some(
              ({ name }) => (collaborations[name] || 0) > 0
            );
            const docs = sociosComp.documents || [];

            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={sociosComp.commitmentCode + "," + sociosComp.applicationId + ',' + index}
              >
                <Card>
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {sociosComp.name}
                    </Typography>
                    <Chip
                      icon={icon}
                      label={label}
                      color={color}
                      variant="outlined"
                      size="small"
                      sx={{ p: 2, mb: 2 }}
                    />
                    <Typography
                      variant="body2"
                      sx={{
                        display: "-webkit-box",
                        overflow: "hidden",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        textOverflow: "ellipsis",
                      }}
                    >
                      Tipo: {getMemberType(sociosComp.type)}
                    </Typography>
                    {getApplicationNameToShow(sociosComp) !== "-" && (
                      <Typography
                        variant="body2"
                        sx={{
                          display: "-webkit-box",
                          overflow: "hidden",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          textOverflow: "ellipsis",
                        }}
                      >
                        Aplicación: {getApplicationNameToShow(sociosComp)}
                      </Typography>
                    )}

                    {getDeadlineDate(sociosComp) !== "-" && (
                      <Typography
                        variant="body2"
                        sx={{
                          display: "-webkit-box",
                          overflow: "hidden",
                          WebkitBoxOrient: "vertical",
                          WebkitLineClamp: 2,
                          textOverflow: "ellipsis",
                        }}
                      >
                        Fecha límite: {getDeadlineDate(sociosComp)}
                      </Typography>
                    )}
                    {docs.length > 0 && (
                      <>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 400, mt: 2, mb: 1 }}
                        >
                          Documentos:
                        </Typography>

                        <Box mt={1}>
                          {docs.map((doc) => {
                            const key = doc.fileId ?? doc.id ?? doc.url;
                            const docLabel =
                              doc.name ||
                              doc.filename ||
                              doc.fileName ||
                              "Documento";

                            return (
                              <Box
                                key={key}
                                component="a"
                                href={doc.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  mb: 1,
                                  px: 1.5,
                                  py: 1,
                                  borderRadius: 1,
                                  border: "1px solid #e0e0e0",
                                  textDecoration: "none",
                                  bgcolor: "#fafafa",
                                }}
                              >
                                <Description
                                  fontSize="small"
                                  sx={{ color: "#005A59" }}
                                />
                                <Typography
                                  variant="body2"
                                  sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {docLabel}
                                </Typography>
                              </Box>
                            );
                          })}
                        </Box>
                      </>
                    )}
                    {hasAnyCount && (
                      <>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 400, mb: 1 }}
                        >
                          Colaboraciones:
                        </Typography>

                        {categories.length > 0 && (
                          <Box mt={1} display="flex" flexWrap="wrap" gap={2}>
                            {categories.map(({ name, icon: IconComponent }) => {
                              const title = compromiso?.title;
                              const count = collaborations[name] || 0;
                              const isDisabled = count === 0;
                              const targetUrl =
                                `/view/ColaboracionesPage?` +
                                `titulo=${title}` +
                                `&receptor=${sociosComp.memberAddress}` +
                                `&categoria=${name}` +
                                `&fechaDesde=${startDate}` +
                                `&fechaHasta=${endDate}`;

                              return (
                                <Tooltip
                                  key={name}
                                  title={`${name}`}
                                  arrow
                                  enterTouchDelay={0}
                                  leaveTouchDelay={3000}
                                >
                                  <Box
                                    onClick={() =>
                                      !isDisabled && Common.goForward(targetUrl)
                                    }
                                    sx={{
                                      textAlign: "center",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      width: 32,
                                      cursor: isDisabled
                                        ? "default"
                                        : "pointer",
                                      opacity: isDisabled ? 0.3 : 1,
                                    }}
                                  >
                                    <IconComponent
                                      fontSize="small"
                                      sx={{ color: "#005A59" }}
                                    />
                                    <Typography
                                      variant="caption"
                                      color="text.primary"
                                    >
                                      {count}
                                    </Typography>
                                  </Box>
                                </Tooltip>
                              );
                            })}
                          </Box>
                        )}
                      </>
                    )}
                  </CardContent>
                  <CardActions sx={{ p: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          startIcon={<ZoomIn />}
                          onClick={() => handleDetalleSocio(sociosComp)}
                          color="primary"
                          disabled={isLoading || showSpinner}
                          size="small"
                        >
                          Detalle
                        </Button>
                      </Grid>
                      {sociosComp?.memberAddress.toLowerCase() !=
                        Web3Manager.MEMBER_DATA.memberAddress.toLowerCase() && (
                        <Grid item xs={12}>
                          <Button
                            fullWidth
                            variant="contained"
                            startIcon={<Handshake />}
                            onClick={() => handleColaborarConSocio(sociosComp)}
                            color="primary"
                            disabled={isLoading || showSpinner}
                            size="small"
                          >
                            Colaborar
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
      {openModalDetallePersona && (
        <DetallePersonaFormMobile
          open={openModalDetallePersona}
          handleClose={handleCloseModalDetallePersona}
          persona={personaSeleccionada}
        />
      )}

      {openModalDetalleEmpresa && (
        <DetalleEmpresaFormMobile
          open={openModalDetalleEmpresa}
          handleClose={handleCloseModalDetalleEmpresa}
          empresa={empresaSeleccionada}
        />
      )}

      {openModalColaboracion && (
        <ModalColaboracionesFormMobile
          colaboracionEditing={null}
          open={openModalColaboracion}
          handleClose={handleCloseModalColaboracion}
          isEditing={false}
          personas={socios.filter(
            (s) => s.type == Constants.MEMBER_TYPE_PERSONA
          )}
          empresas={socios.filter(
            (s) => s.type == Constants.MEMBER_TYPE_EMPRESA
          )}
          principios={principios}
          compromisos={compromisos}
          categoriasColaboracion={categoriasColaboracion}
          setLoading={setLoading}
          initData={modalColaboracionInitData}
        />
      )}
    </Box>
  );
};
